import { db, auth } from "../firebase/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

// =========================
// REGISTRAR EVENTO
// =========================
export const registrarEvento = async ({
  session_id,
  evento,
  pregunta,
  opcion = null
}) => {
  try {
    const user = auth.currentUser;

    const opcionNormalizada = opcion ? opcion.toLowerCase() : null;
    const correctaNormalizada = pregunta?.Respuesta
      ? pregunta.Respuesta.toLowerCase()
      : null;

    await addDoc(collection(db, "eventos_quiz"), {
      session_id,
      userId: user ? user.uid : null,

      evento,

      pregunta_id: pregunta?.ID || null,
      examen: pregunta?.Examenes || null,

      opcion: opcionNormalizada,
      correcta: correctaNormalizada,

      es_correcta:
        opcionNormalizada && correctaNormalizada
          ? opcionNormalizada === correctaNormalizada
          : null,

      timestamp: serverTimestamp(),
    });

  } catch (error) {
    console.error("Error registrando evento:", error);
  }
};